import Vuex from 'vuex'

import app from './app'
import workOrders from './workOrders'
import vehicles from './vehicles'

export default new Vuex.Store({
  modules: {
    app,
    workOrders,
    vehicles,
  },
})
